import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Card, Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const token = Cookies.get('authToken')

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
})

const SeeCanceledBooking = () => {
  const [allBookings, setAllBookings] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchBookingsData = async () => {
    setLoading(true)
    try {
      const bookingsUrl =
        BASE_URL+'/get/cancel/bookings'
      const bookingResponse = await axiosInstance.get(bookingsUrl)
      console.log('Fetching bookings from:', bookingsUrl)

      if (
        !bookingResponse.data ||
        !bookingResponse.data.data ||
        bookingResponse.data.data.length === 0
      ) {
        console.log('No bookings available')
        setAllBookings([])
        return
      }

      const bookings = bookingResponse.data.data

      const [
        customerResponse,
        brokerResponse,
        plotResponse,
        siteResponse,
      ] = await Promise.all([
        axiosInstance.get('customer/search'),
        axiosInstance.get('brokers/search'),
        axiosInstance.get('plot/search'),
        axiosInstance.get('sites'),
      ])

      const customers = customerResponse.data.data
      const brokers = brokerResponse.data.data
      const plots = plotResponse.data.data
      const sites = siteResponse.data.data

      console.log('Brokers data:', brokers)
      console.log('Booking data:', bookings)

      const enrichedBookings = bookings.map((booking) => {
        const customer =
          customers.find((c) => c.id === booking.customer_id) || {}

        console.log(
          `Booking ID: ${booking.id}, Booking Broker ID: ${booking.broker_id}`,
        )

        const broker =
          brokers.find((b) => b.broker_id === booking.broker_id) || {}

        const brokerName = broker ? broker.name : 'Not assigned'

        const plot = booking.plot_details?.[0] || {}
        const plotData = plots.find((p) => p.id === booking.plot_id) || {}
        const site = sites.find((s) => s.id === plotData.site_id) || {}

        return {
          ...booking,
          customer_name: customer.name || booking.customer_name,
          customer_title: customer.title || booking.customer_title,
          broker_name: brokerName || 'Not assigned',
          site_name: site.name || plot.site_name,
          plot_number: plotData.plot_number || booking.plot_number,
        }
      })

      console.log('Enriched bookings:', enrichedBookings)
      setAllBookings(enrichedBookings)
    } catch (error) {
      console.error('Error fetching booking details:', error)
      toast.error(
        error.response?.data?.message || 'Failed to fetch booking details',
      )
    } finally {
      setLoading(false)
    }
  }
  const formatBookingDateTime = (bookingDate) => {
    const date = new Date(bookingDate)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      window.location.href = '/login'
    } else {
      axiosInstance.defaults.headers.Authorization = `Bearer ${token}`
      fetchBookingsData()
    }
  }, [])

  return (
    <>
      <Container
        className="mt-0"
        style={{ maxWidth: '1150px' }}
      >
        <div className="pb-3 rounded-3">
          {/* <Card.Header className="text-success text-center bg-light">
            <h2 className="mb-2 fw-bold">All Canceled Bookings</h2>
          </Card.Header> */}

          <div className='px-2 mb-3' style={{ backgroundColor: theme.colors.background }}>
            <Table
               bordered
               hover
               responsive="md"
               className="text-center table-striped table-bordered table-hover"
             >
               <thead
                 className="position-sticky top-0 text-start"
                 style={{
                   backgroundColor: theme.colors.secondary,
                   color: theme.colors.primary
                 }}
               > 
                  <tr>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking ID</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Date</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Status</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Amount</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Customer Name</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Associate Name</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Name</th>
                    <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Number</th>
                  </tr>

              </thead>
              <tbody className="text-start">
                {loading ? (
                  <tr>
                    <td colSpan={10} className="text-center">
                      Loading bookings...
                    </td>
                  </tr>
                ) : allBookings.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="text-center text-danger">
                      No bookings are available for the selected date range
                    </td>
                  </tr>
                ) : (
                  allBookings.map((booking) => (
                    <tr key={booking.id}>
                      <td>{booking.id}</td>
                      <td>{formatBookingDateTime(booking.booking_date)}</td>
                      <td>{booking.booking_status}</td>
                      <td>₹ {booking.booking_price}</td>
                      <td>{`${booking.customer_title}. ${booking.customer_name}`}</td>
                      <td>{booking.broker_name} </td>
                      <td>{booking.site_name}</td>
                      <td>{booking.plot_number}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Container>
    </>
  )
}

export default SeeCanceledBooking
